export default "__VITE_ASSET__Dns02JGX__"